import { ComponentType, useMemo } from 'react';
import { getFilterBannerIds } from './get-filter-banner-ids';
import { CommonBannerProps } from '../AllTherapists/components/banners/BannerBase';
import { DiseaseGroupResponseDto } from '@app/api';
import { linkedReligionBanners } from './link-religions-with-banner';

interface UseCurrentBannerArguments {
  query: Record<string, any> | undefined;
  diseasesGroups: DiseaseGroupResponseDto[] | undefined;
}

type UseCurrentBanner = (args: UseCurrentBannerArguments) => {
  CurrentBanner: ComponentType<CommonBannerProps> | undefined;
  sleepProblemsId: string | undefined;
};

export const useFilterBannerManager: UseCurrentBanner = ({
  diseasesGroups,
  query,
}) => {
  const diseases = useMemo(() => {
    return getFilterBannerIds(diseasesGroups);
  }, [diseasesGroups]);

  const mergedFilters = useMemo(() => {
    return [...diseases, ...linkedReligionBanners];
  }, [diseases]);

  const params: any[] = useMemo(() => {
    if (!query) return [];

    return ['diseases', 'religions'].reduce((q, current) => {
      const filterValues = query[current];

      if (filterValues && Array.isArray(filterValues)) {
        return [...q, ...filterValues];
      }

      return q;
    }, [] as any[]);
  }, [query]);

  const CurrentBanner = useMemo(() => {
    if (params.length !== 1) return;

    const currentParam = params[0];

    return mergedFilters.find((item) => item.id === currentParam)?.Component;
  }, [params, mergedFilters]);

  return {
    CurrentBanner,
    sleepProblemsId: diseases.find((item) => item.isAskona)?.id,
  };
};
